import { Injectable } from "@angular/core";
import { SelectLocationComponent } from "../components/select-location/select-location.component";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Observable } from "rxjs";
import { count } from "rxjs/operators";
import { UnlServiceService } from "./unl-service.service";
@Injectable({
  providedIn: "root"
})
export class LocationService {  
  
  private selectedOption = "All Countries";
  private selectedCountry: number = 0;
  country_Id;
  state_Id;
  country_Url;
  state_Url;
  city_Url;
  desc_Path;
  descCurrentnodeId;
  item 
  rmi
  setData(selectedOption) {
    this.selectedOption = selectedOption;
  }
  getData() {
    return this.selectedOption;
  }
  rmindex(rmi,item){
    this.rmi=rmi;
    this.item=item;
    // console.log("ttt",this.rmi,this.item)
  }
  getrmindex(){
    // console.log("www",this.rmi)
    return[this.rmi,this.item];
   
  }
  setSelectedCountry(value: number): void {
    this.selectedCountry = value;
  }

  getSelectedCountry(): number {
    return this.selectedCountry;
  }
  constructor(private http: HttpClient,private unlServiceService: UnlServiceService) {
    this.country_Url =  this.unlServiceService.basepath+"testunl/views/unl_service_get_country_list.json?limit=0&args=null";
  }
  allCountries(): Observable<any> {
    return this.http.get(this.country_Url);
  }
  allStates(country_Id): Observable<any> {
    this.state_Url =this.unlServiceService.basepath+"testunl/views/unl_service_getstates.json?limit=0&args=" +
      country_Id;
    console.log("country ID", country_Id);
    return this.http.get(this.state_Url);
  }
  allCity(state_Id): Observable<any> {
    this.city_Url =this.unlServiceService.basepath+"testunl/views/unl_service_getstates.json?limit=0&args=" +
      state_Id;
    return this.http.get(this.city_Url);
  }
  
  getIndex(i) {
    this.descCurrentnodeId = i;
  }
  setIndex() {
    return this.descCurrentnodeId;
  }
  getDescPath(path) {
    this.desc_Path = path;
    this.setDescPath();
  }
  setDescPath() {
    return this.desc_Path;
  }

}
